import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.css';
import './styles/dark-mode.css';
import './styles/dot-background.css';
// Vendor design system — scoped to the shared page containers
// (.invoice-container / .vendors-container / .vendor-registration-details / …).
// The Vendor account's pages already import this; loading it globally applies
// the SAME design system (tables, filters, search, pagination, status pills,
// inputs, titles) consistently across every role without touching any logic.
import './styles/forms-redesign.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>,
  rootElement);
registerServiceWorker();
